import { grey } from "@mui/material/colors";

export const entryTableFont = {
  fontSize: 18
};

export const entryTableBoldFont = {
  fontWeight: "bold",
  fontSize: 20,
};

export const entryTableGridColumnSpacing = 2;

export const entryTableHeaderStyle = {
  backgroundColor: grey[100],
  "& .MuiGrid-item" : {
    ...entryTableFont,
    marginY: "auto",
  }

}

export const entryTableRowStyle = {
  product: {
    minWidth: "360px",
    width: "calc((100vw-120px) * 18%)",
    position: "sticky",
    left: 0,
    zIndex: 10
  },
  detail: {
    minWidth: "1500px" ,
    width: "calc((100vw-120px) * 75%)",
  },
  showSalesRecordButton: {
    minWidth: "120px"
  }
}

export const productPartColumnWidths = {
  salesRecordNo: {
    minWidth: "120px",
    width: "32%"    
  },
  productName: {
    minWidth: "120px",
    width: "32%" 
  },
  needsPrintForEachDetail : {
    minWidth: "90px",
    width: "25%"
  }
}

export const detailRowColumnWidths = {
  plusButton: {
    width: "60px"
  },
  minusButton: {
    width: "60px"
  },
  origin: {
    minWidth: "120px",
    width: "8%" 
  },
  rank: {
    minWidth: "120px",
    width: "8%"    
  },
  productClass: {
    minWidth: "120px",
    width: "8%"    
  },
  packing: {
    minWidth: "120px",
    width: "8%"    
  },
  supplyWeight: {
    minWidth: "100px",
    width: "6%" 
  },
  supplyUnitName: {
    minWidth: "60px",
    width: "4%" 
  },
  supplyUnitQuantity: {
    minWidth: "60px",
    width: "4%" 
  },
  supplyQuantity: {
    minWidth: "60px",
    width: "4%" 
  },
  acceptanceLabelNo: {
    width: "100px",
  },
  weight: {
    width: "100px",
  },
  partition: {
    width: "100px"
  },
  directorEmployeeId: {
    width: "100px",
  },
  quantity: {
    width: "100px",
  },
  purchacePrice: {
    width: "100px",
  }
    
}